import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const { status, data } = error.response
      
      if (status === 401) {
        localStorage.removeItem('token')
        window.location.href = '/'
      }
      
      return Promise.reject({
        status,
        message: data?.message || '请求失败',
        errors: data?.errors || []
      })
    }
    
    return Promise.reject({
      status: 0,
      message: '网络错误，请检查网络连接'
    })
  }
)

// API 方法
export const userAPI = {
  register: (data) => api.post('/users/register', data),
  login: (data) => api.post('/users/login', data),
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data) => api.put('/users/profile', data)
}

export const assessmentAPI = {
  submitBasic: (data) => api.post('/assessment/basic', data),
  getMatchResult: (id) => api.get(`/assessment/result/${id}`),
  submitPrecision: (data) => api.post('/assessment/precision', data),
  getPrecisionReport: (id) => api.get(`/assessment/report/${id}`)
}

export const paymentAPI = {
  createOrder: (data) => api.post('/orders/create', data),
  getOrderStatus: (orderId) => api.get(`/orders/${orderId}/status`),
  getPaymentConfig: () => api.get('/payment/config'),
  requestRefund: (orderId) => api.post(`/orders/${orderId}/refund`)
}

export const packageAPI = {
  getPackages: () => api.get('/packages'),
  getPackageDetail: (id) => api.get(`/packages/${id}`),
  getMyPackages: () => api.get('/packages/my')
}

export const contentAPI = {
  getIntelligence: (params) => api.get('/content/intelligence', { params }),
  getInterviewQuestions: (params) => api.get('/content/interview-questions', { params }),
  getVocabulary: () => api.get('/content/vocabulary'),
  getResumeTemplates: () => api.get('/content/resume-templates')
}

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
  getCharts: () => api.get('/dashboard/charts')
}

export default api
